import AutocompleteField from '@/modules/core/components/shared/AutocompleteField/AutocompleteField'

export default AutocompleteField
